<!--
 * @Descripttion: 
 * @version: 
 * @Author: yuhongyou
 * @Date: 2021-05-28 13:14:30
 * @LastEditors: yuhongyou
 * @LastEditTime: 2021-11-12 13:49:15
-->
<template>
<div class="BigScreenEcharts">
  <el-dialog :title="bigScreenEcharts.item.name" :visible.sync="bigScreenEcharts.show" width="80%" :before-close="handleClose">
    <component :is="bigScreenEcharts.item.componentName" :big='big' :flag="true" v-if="bigScreenEcharts.show"></component>
  </el-dialog>
</div>
</template>

<script>
export default {

  components: {
    com1: () => import(/* webpackChunkName: "screen-charts" */ "@/components/firstPage/DeviceEcharts"),
    com2: () => import(/* webpackChunkName: "screen-charts" */ "@/components/firstPage/DangerEcharts"),
    com3: () => import(/* webpackChunkName: "screen-charts" */ "@/components/firstPage/AangerEcharts"),
    com4: () => import(/* webpackChunkName: "screen-charts" */ "@/components/firstPage/BangerEcharts"),
    com5: () => import(/* webpackChunkName: "screen-charts" */ "@/components/firstPage/CangerEcharts"),
    com6: () => import(/* webpackChunkName: "screen-charts" */ "@/components/firstPage/EangerEcharts"),
    com7: () => import(/* webpackChunkName: "screen-charts" */ "@/components/firstPage/FangerEcharts"),
    com8: () => import(/* webpackChunkName: "screen-charts" */ "@/components/firstPage/GangerEcharts"),
    com9: () => import(/* webpackChunkName: "screen-charts" */ "@/components/firstPage/HangerEcharts"),
    com10: () => import(/* webpackChunkName: "screen-charts" */ "@/components/firstPage/IangerEcharts"),
  },
  props: {
    bigScreenEcharts: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      dialogVisible: true,
      componentName: 'com1',
      show: true,
      big:false
    }

  },
  created() {
    console.log(`this.bigScreenEcharts.item.componentName`, this.bigScreenEcharts.item.componentName);
    if(this.bigScreenEcharts.show){
      this.big = true
    }
  },
  methods: {
    handleClose(done) {
       this.$emit('closeDialog')
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     // done();
      //     this.$emit('closeDialog')
      //   })
      //   .catch(_ => {});

    }
  },
}
</script>

<style lang="scss">
.BigScreenEcharts {

  // height: 100%;
  // width: 80%;
  .el-dialog {
    height: 80%;
    background-color: #42546c;
    display: flex;
    flex-direction: column;

    .el-dialog__header {
      height: 55px;

      .el-dialog__title {
      font-size: 30px;
        color: #fff;
        text-shadow: 0 0 0 var(--monitorBorder, #3beff0), 0 0 4px var(--monitorBorder, #3beff0), 0 0 0 var(--monitorBorder, #3beff0), 0 0 4px var(--monitorBorder, #3beff0);
      }

    }

    .el-dialog__body {
      flex: 1;
      overflow: auto;
    }
  }
}
</style>
